import template from './leave_categories_component.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class AdminLeaveCategoriesComponentViewModel
{
	constructor(page)
	{
		this.page = page;
		this.categories = ko.observableArray();

		this.init();
	}

	async updateData()
	{
		let res = await Grape.fetches.getJSON('/api/record', { table: 'leave_category', limit: 1000000 });
		if (res.status !== 'ERROR')
			this.categories(res.records);

		Utils.refresh_data_visible_roles();
	};

	async init()
	{
		this.updateData();
	};

	btn_cancel_save(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().prev();
		let edit_row = $(e.currentTarget).parent().parent();
		view_row.show();
		edit_row.hide();
		this.updateData();
	}


	edit_leave_category(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().parent();
		let edit_row = $(e.currentTarget).parent().parent().parent().next();

		view_row.hide();
		edit_row.show();
	};

	add_leave_category(v, e)
	{
		let categories = v.categories;
		categories.unshift({ category: '' });
		let row = $('#body > tr:first-child');

		row.hide();
		row.next().show();
	};

	async delete_leave_category(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().parent().parent().prev();
		let edit_row = $(e.currentTarget).parent().parent().parent();
		let data = ko.mapping.toJS(v);

		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to delete this category entry ?')});
		if (response)
		{
			let res = await Grape.fetches.postJSON('/admin/leave_category_delete', data);
			if (res.status == 'OK')
			{
				Grape.alerts.alert({ type: 'success', message: tr('Successfully deleted category.'), title: tr('Success') });
				this.updateData();
				edit_row.hide();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
		}
	};

	async save_leave_category(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().prev();
		let edit_row = $(e.currentTarget).parent().parent();
		let data = ko.mapping.toJS(v);

		let res = await Grape.fetches.postJSON('/admin/leave_category_upsert', data);
		if (res.status == 'OK')
		{
			Grape.alerts.alert({ type: 'success', message: tr('Successfully saved category.'), title: tr('Success') });
			this.updateData();
			edit_row.hide();
		}
		else if (res.status == 'ERROR')
		{
			Grape.alerts.apiError(res);
			this.updateData();
		} else if (res.error)
		{
			Grape.alerts.alert({ type: 'error', message: res.error, title: tr('Error') });
			this.updateData();
		} else
			Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });

		view_row.show();
		edit_row.hide();
	};
}

export default {
	name: 'leave_categories_component',
	viewModel: AdminLeaveCategoriesComponentViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/leave_categories_component'
};
